<template>
    <td class="stage__col stage__col_responsible">
        <Select
            :name="`responsible[]`"
            :items="allowedUsers"
            :active="responsibleUserId"
            @selectChange="v => $emit('update', v)"
        />
    </td>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "StageResponsible",
    props: ['responsibleUserId'],
    computed: {
        ...mapState({
            users: state => state.planUrlTask.users,
        }),
        allowedUsers() {
            const usersList = [...this.users].map((el) => ({...el, label: this.getLabel(el), labelPostfix: el.email || ''}));
            return [{id: 0, lastname: 'Не выбран', label: 'Не выбран', labelPostfix: ''}, ...usersList];
        }
    },
    methods: {
        getLabel(user) {
            return (user.lastname || '') + ' ' + (user.firstname || '');
        },
    }
}
</script>
